import React from 'react';
import BaseComponent from '../common/BaseComponent/BaseComponent';

const ContextTLD = React.createContext({});


/**
 * @class ContextTLDProvider
 * @property {{tldAll:Array<TLDData>, tldCat: Array<TLDCategory>, tldTag: Array<TLDTags>, defaultTag: TLDTags}} contextData
 * @property {Function} getAllTLDs Връща всички TLD-та
 * @property {Function} getForCategory Връща TLD-та от дадена категория
 * @property {Function} getAllTLDCategories Връща всички TLD категории
 * @property {Function} getAllTags Връща всички TLD тагове
 * @property {Function} getDefaultTag Връща всички TLD таг-а по подразбиране
 * @property {Function} getPromotions
 *
 */
class ContextTLDProvider extends BaseComponent {

	constructor(props) {

		super(props);

		this.componentName = SHVO.pageState.componentData.contextTLDProvider.componentName;
		this.componentToken = SHVO.pageState.componentData.contextTLDProvider.componentToken;


		this.state = {
			contextData: SHVO.pageState.componentData.contextTLDProvider.componentData,
			getAllTLDs: this.getAllTLDs,
			getAllTLDCategories: this.getAllTLDCategories,
			getAllTags: this.getAllTags,
			getDefaultTag: this.getDefaultTag,
			getForCategory: this.getForCategory,
			validateDomainName: this.validateDomainName,
			validateTLDForTransfer: this.validateTLDForTransfer,
			getPromotions: this.getPromotions,
		}
	}

	/**
	 * Връща всички TLD-та
	 * @returns {Array<TLDData>}
	 */
	getAllTLDs = () => {
		return this.state.contextData.tldAll;
	};

	getPromotions = () => {
		return this.state.contextData.promotions;
	}

	/**
	 * Връща всички TLD tagowe
	 * @returns {Array<TLDTags>}
	 */
	getAllTags = () => {
		return this.state.contextData.tldTag;
	};
	/**
	 * Връща всички TLD таг-а по подразбиране
	 * @returns {TLDTags}
	 */
	getDefaultTag = () => {
		return this.state.contextData.defaultTag;
	};
	/**
	 * Връща всички TLD категории
	 * @returns {Array<TLDCategory>}
	 */
	getAllTLDCategories = () => {
		return this.state.contextData.tldCat;
	};

	/**
	 * Връща TLD-та от дадена категория
	 *
	 * @param {{string}} category_id Ако се category_id е all, връща всички tld-та
	 * @returns {Array<TLDData>}
	 */
	getForCategory = (category_id) => {
		const arrTLDData = this.state.contextData.tldAll;
		if (category_id === 'all') {

			let unique = {};
			arrTLDData.map((tldData) => {
				unique[tldData.id] = tldData;
			});

			return Object.values(unique);
		}
		return [...arrTLDData.filter(tldData => tldData.category_id === category_id)];
	};

	/**
	 * Проверка за валидно име на домейн.
	 * Валидното име на домейн е:
	 * - Изписано само с латиница (за всички TLD-та)
	 * - Изписано само на кирилица (за определени TLD-та)
	 * - XN име (започващо с XN--)
	 * Невалидното име на домейн:
	 * - Изписано едновременно на латиница/кирилица.
	 * - Започващо/завърщващо с тире.
	 * - Невалидно XN име (което не се транслира правилно към кирилица).
	 **/
	validateDomainName = (domainNameFull, isTransfer) => {
		// Валидира име на домейн.

		/**
		 * https://jira.superhosting.bg/browse/ORDER-35
		 */
		domainNameFull = domainNameFull.replace(/^www\./, '');

		domainNameFull = domainNameFull.toLowerCase().trim();
		const arrDomainData = domainNameFull.split('.');
		const domainName = arrDomainData[0];
		const domainTld = domainNameFull.substring(domainName.length + 1, domainNameFull.length);
		////////////////////////////////////////////
		////////////////////////////////////////////
		/**
		 * https://pi.superhosting.bg/public/index.php?path_info=projects%2Fanglijska-versiya-testvane%2Ftasks%2F53
		 * Поне два символа
		 */
		if (domainName.length <= 2) {
			throw 'DOMAIN_NAME_LENGTH_ERROR';
		}
		////////////////////////////////////////////
		////////////////////////////////////////////
		const t = domainNameFull.replace(' ', '');
		if (t !== domainNameFull) {
			throw 'DOMAIN_NAME_INVALID_ERROR';
		}
		////////////////////////////////////////////
		////////////////////////////////////////////
		const domTmp = domainName.replace(/[.`!,?<>/()*@#%]/gi, '');
		if (domTmp !== domainName) {
			throw 'DOMAIN_NAME_DISALLOWED_ERROR';
		}
		////////////////////////////////////////////
		////////////////////////////////////////////
		// Валидира името на домейна, ако името на домейна е с латински букви.
		const dNum = domainName.replace(/[0123456789-]/gi, '');
		const dEn = domainName.replace(/[abcdefghijklmnopqrstuvwxyz0123456789-]/gi, '');
		const dBg = domainName.replace(/[абвгдежзийклмнопрстуфхцчшщъыьэюя0123456789-]/gi, '');
		if (dNum === '') {
			return;
		}

		/*Проверка дали съдържа едновременно и БГ символи и EN символи.*/
		if ((dEn !== '') && (dBg !== '')) {
			throw  'DOMAIN_NAME_INVALID_CYR_LAT_ERROR';
		}
		////////////////////////////////////////////
		////////////////////////////////////////////
		// Проверка дали името започва или завършва с тире.
		const dTmp = domainName.replace(/^-+|-+$/g, '');
		if (dTmp !== domainName) {
			throw 'DOMAIN_NAME_HYPHEN_ERROR';
		}
		////////////////////////////////////////////
		////////////////////////////////////////////
		let tldData = {};

		let allTLD = this.getAllTLDs();
		let domainTLDS = {};

		if (!this.domainTLDS) {
			allTLD.forEach((item) => {
				domainTLDS[item.code] = item;
			});
			this.domainTLDS = domainTLDS;
		}
		domainTLDS = this.domainTLDS;

		if (domainTld) {
			tldData = domainTLDS[domainTld];

			if (typeof tldData === 'undefined') {
				throw 'DOMAIN_TLD_INVALID_ERROR';
			}

			if (parseInt(tldData.is_active) === 0) {
				throw 'DOMAIN_TLD_INVALID_ERROR';
			}

			if (parseInt(tldData.transferable === 0)) {
				throw 'DOMAIN_TLD_INVALID_ERROR';
			}
		}
		/**
		 * https://ps.superhosting.bg/projects/350?modal=Task-22909-350
		 * Проверява се дали даденото TLD има изискване името на домейна да е само на кирилица
		 */

		if (parseInt(tldData.rxn) === 1) {
			const domTmpTLD = domainName.replace(/[абвгдежзийклмнопрстуфхцчшщъыьэюя0123456789-]/gi, '');
			if (domTmpTLD !== '') {
				throw 'DOMAIN_NAME_LANG_ERROR';
			}
		}

		let allowXN = (parseInt(tldData.axn) === 1);
		if (parseInt(isTransfer) === 1) {
			allowXN = (parseInt(tldData.axnt) === 1);
		}
		const isXN = (domainName.substr(0, 4) === 'xn--');
		const registrar = tldData.regs;
		if (isXN && !allowXN) {
			throw 'DOMAIN_NAME_XN_ERROR';
		}
		if ((dBg === '') && !allowXN) {
			throw 'DOMAIN_NAME_XN_ERROR';
		}


		/**
		 * Ако домейна на кирилица и registrar-а е Регистър.БГ. се проверява
		 * дали в името на домейна има поне 1 буква, която да не прилича на латинското
		 * си изписване:
		 * Когато ИНТЕРНЕТ ИМЕТО се изписва на кирилица (IDN), то трябва да съдържа букви
		 * само от кирилицата и да включва поне една отличаваща се визуално буква спрямо
		 * латинската азбука (големи и/или малки букви): б, г, д, ж, и, й, л, п, ф, ц, ч, ш, щ, ъ, ь, ю, я.
		 * https://www.register.bg/user/static/rules/bg/index.html
		 */
		if (registrar === 'RBG' || (isTransfer && registrar === 'IBGCYR')) {
			// Дали домейна е на кирилица:
			if ((dBg === '') && (dNum !== '')) {
				const idnBG = domainName.replace(/[бгджийлпфцчшщъьюя]/gi, '');

				if (idnBG === domainName) {
					throw 'DOMAIN_NAME_IDN_BG_LETTER_ERROR';
				}
			}
		}
	};

	validateTLDForTransfer = (tld) => {

		let allTLD = this.getAllTLDs();
		let domainTLDS = {};

		if (!this.domainTLDS) {
			allTLD.forEach((item) => {
				domainTLDS[item.code] = item;
			});
			this.domainTLDS = domainTLDS;
		}
		domainTLDS = this.domainTLDS;
		if (typeof domainTLDS[tld] === 'object') {
			const tldData = domainTLDS[tld];
			if (tldData.altr == '1') {
				return;
			}
			throw 'DOMAIN_TLD_INVALID_ERROR';
		}
		throw 'DOMAIN_TLD_INVALID_ERROR';
	}

	render() {
		return (
			<ContextTLD.Provider value={this.state}>
				{this.props.children}
			</ContextTLD.Provider>
		)
	}
}

export {ContextTLD, ContextTLDProvider};


/**
 * @typedef {Object} TLDData
 * @property {string} id - ID на TLD-то
 * @property {string} code - Кодът на TLD-то. Показва се в сайта.
 * @property {number} priority - Приоритет на TLD-то. Използва се за подредба.
 * @property {boolean} has_special_page - Указва дали дадено TLD има детайлна страница.
 * @property {boolean} transferable - Указваща дали TLD-то може да се трансферира
 * @property {string} transfer_id - ID на услугата за трансфер
 * @property {string} category - Име на категория
 * @property {string} category_id - ID на категорията
 * @property {number} category_order - подредба в категорията
 * @property {Array.<TLDLabelData>} labels - Label-и за дадено TLD
 */


/**
 * @typedef {Object} TLDCategory
 * @property {string} id - ID на Категорията
 * @property {string} name - Име на категорията.
 * @property {string} anchor - Код, който се използва за закотвяне на страницата.
 * @property {number} order - Подредба
 * @property {boolean} isNew - Дали е нова категория
 * @property {boolean} isDefault - Дали е категория по подразбиране
 * @property {boolean} isActive - Дали е активна категория
 */


/**
 * @typedef {Object} TLDTags
 * @property {string} id - ID на Таг-а
 * @property {string} name - Име на таг.
 * @property {number} order - Подредба.
 * @property {string} anchor - Котва в страницата
 * @property {boolean} active - Дали е активен
 * @property {boolean} default - Дали е категория по подразбиране
 */


/**
 * @typedef {Object} TLDLabelData
 * @property {string} tld - Указва към кое тлд е label-а.
 * @property {string} background_color - Цвят на фона на label-а
 * @property {string} name - Текст на label-а.
 * @property {string} text_color - Цвят на текста на label-а.
 */
